import React, { useState } from 'react';
import { View, ScrollView, MediaStories } from '@upstox/upstox-ui';
import Image from 'next/image';
import * as css from './Slider.style';
import Overlay from '../../../Overlay';

type props = {
  sliderImages?: {
    alt?: string;
    url?: string;
    title?: string;
  }[];
};

const Slider = ({ sliderImages }: props) => {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <>
      <ScrollView inline autoHeight autoHeightMax="100%" gap={'small'}>
        {/* Slider Items starts here */}
        {sliderImages &&
          sliderImages.map((item) => {
            return (
              item.url && (
                <View
                  onClick={() => setShowDetails(true)}
                  key={item.url}
                  style={{
                    position: 'relative',
                    width: '155px',
                    height: '155px',
                    cursor: 'pointer',
                  }}
                >
                  <Image
                    loader={() => item.url}
                    src={item.url}
                    alt={item.alt || 'img'}
                    width="100%"
                    height="100%"
                    layout="fill"
                    objectFit="contain"
                  />
                </View>
              )
            );
          })}
        {/* Slider Items ends here */}
      </ScrollView>

      {showDetails && (
        <Overlay onClose={() => setShowDetails(false)}>
          <MediaStories
            stories={sliderImages.map((item) => {
              return { type: 'image', url: item.url };
            })}
          />
        </Overlay>
      )}
    </>
  );
};

export default Slider;
